import { SECTION2 } from "../../content/copy";
import { Reveal } from "../Reveal";
import { SplitHeadline } from "../fx/SplitHeadline";
import { SectionMark, Folio, RegMarks } from "../fx/Marginalia";

const BREAK = "Invece era una resa.";
const [p1, p2, p3] = SECTION2.paragraphs;
const p1Head = p1.slice(0, p1.indexOf(BREAK)).trimEnd();

export const OppositeSpread = () => (
  <section className="sec s2 bg-b" data-testid="section-repositioning" data-rail="02">
    <RegMarks />
    <div className="frame">
      <SectionMark n="02" label="RIPOSIZIONAMENTO" />
      <div className="g12 s2-grid">
        <SplitHeadline as="h2" className="s2-title" text={SECTION2.title} emIdx={[12, 13, 14, 15]} testid="section2-title" />
        <aside className="s2-aside mono" aria-hidden="true">
          <span>LEGGE DELL'OPPOSTO</span>
          <span>02.A — DELEGA</span>
          <span>02.B — RESA</span>
        </aside>
        <div className="s2-prose prose">
          <Reveal as="p" className="lede dropcap" data-testid="section2-paragraph-1">
            {p1Head} <span className="break-point">{BREAK}</span>
          </Reveal>
          <Reveal as="p" delay={150} data-testid="section2-paragraph-2">{p2}</Reveal>
        </div>
        <Reveal className="s2-pull serif" aria-hidden="true" data-testid="section2-pullquote">
          tra scegliere di affidarsi e ritrovarsi affidati
        </Reveal>
        <div className="s2-prose-b prose">
          <Reveal as="p" data-testid="section2-paragraph-3">{p3}</Reveal>
        </div>
      </div>
      <Folio n="02" />
    </div>
  </section>
);
